// extracted by mini-css-extract-plugin
module.exports = {"orgList":"addorg_orgList__1JyIE"};